import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchRfidUploadedFilesList = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRfidUploadedFilesList',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceUrl);
};

export default apiFetchRfidUploadedFilesList;
